<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="icon-people"></i> Cadastro
                <b-link :to="`/dashboard`" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <form @submit.prevent="validate" class="needs-validation" novalidate>
                    <div class="form-row">
                        <div class="col-sm-6">
                            <base-input type="text" label="Nome" required placeholder="Digite seu nome" v-model="model.givenName" v-validate="modelValidations.givenName" data-vv-name="givenName" data-vv-as="nome" maxlength="100" :error="getError('givenName')" />
                        </div>
                        <div class="col-sm-6">
                            <base-input required label="Sobrenome" type="text" placeholder="Digite seu sobrenome" v-model="model.familyName" v-validate="modelValidations.familyName" data-vv-name="familyName" data-vv-as="sobrenome" maxlength="150" :error="getError('familyName')" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-4">
                            <base-input required label="Cpf" type="tel" placeholder="Digite seu cpf" v-model="model.personalInfo.document" v-validate="modelValidations.document" data-vv-name="document" data-vv-as="cpf" :mask="['###.###.###-##']" :error="getError('document')" />
                        </div>
                        <div class="col-sm-4">
                            <base-input label="RG" required type="text" maxlength="20" placeholder="Digite seu RG" v-model="model.personalInfo.regionalDocument" v-validate="modelValidations.regionalDocument" data-vv-name="regionalDocument" data-vv-as="RG" :error="getError('regionalDocument')" />
                        </div>
                        <div class="col-sm-4 justify-content-start">
                            <base-input label="Data Nascimento" type="tel" placeholder="Digite sua data de aniversario" v-model="model.personalInfo.birthDate" :masked="true" :mask="['##/##/#####']" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6 justify-content-start">
                            <div class="form-group">                                
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input v-model="model.personalInfo.gender" type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" :value="0">
                                    <label class="custom-control-label" for="customRadioInline1">Masculino</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input v-model="model.personalInfo.gender" type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" :value="1">
                                    <label class="custom-control-label" for="customRadioInline2">Feminino</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-6">
                            <base-input required label="E-mail" type="email" placeholder="Digite seu e-mail" v-model="model.email" v-validate="modelValidations.email" :error="getError('email')" data-vv-name="email" data-vv-as="e-mail" maxlength="256" />
                        </div>
                        <div class="col-sm-6">
                            <base-input required label="Telefone" type="tel" placeholder="Digite seu telefone" v-model="model.phoneNumber" v-validate="modelValidations.phoneNumber" :error="getError('phoneNumber')" data-vv-name="phoneNumber" data-vv-as="telefone" :mask="['(##) ####-####', '(##) #####-####']" />
                        </div>
                    </div>                    
                    <div class="form-row">
                        <div class="col-sm-2 justify-content-start">
                            <base-input required label="Cep" type="tel" placeholder="Digite seu Cep" v-model="model.address.zipCode" v-validate="modelValidations.zipCode" :error="getError('zipCode')" data-vv-name="zipCode" data-vv-as="cep" :mask="['#####-###']" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-8">
                            <base-input required label="Logradouro" type="text" placeholder="Digite o endereço" v-model="model.address.street" v-validate="modelValidations.street" :error="getError('street')" data-vv-name="street" data-vv-as="endereço" maxlength="255" />
                        </div>
                        <div class="col-sm-4">
                            <base-input requried label="Número" type="text" placeholder="Digite o numero" v-model="model.address.number" v-validate="modelValidations.number" :error="getError('number')" data-vv-name="number" data-vv-as="número" maxlength="20" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-4">
                            <base-input label="Complemento" type="text" placeholder="Digite o complemento" v-model="model.address.complemento" maxlength="250" />
                        </div>
                        <div class="col-sm-4">
                            <base-input required label="Bairro" type="text" placeholder="Digite o bairro" v-model="model.address.district" v-validate="modelValidations.district" :error="getError('district')" data-vv-name="district" data-vv-as="bairro" maxlength="250" />
                        </div>
                        <div class="col-sm-4">
                            <base-input required label="Cidade" type="text" placeholder="Digite a cidade" v-model="model.address.city" v-validate="modelValidations.city" :error="getError('city')" data-vv-name="city" data-vv-as="cidade" maxlength="250" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-4 justify-content-start">
                            <div class="form-group">
                                <label for="exampleFormControlSelect1">Estado</label>
                                <select :class="{'form-control': true, 'is-invalid': errors.has('state')}" v-validate="modelValidations.state" v-model="model.address.state" data-vv-name="state" data-vv-as="estado">
                                    <option value="">Selecione um estado:</option>
                                    <option v-for="(s, index) in stateList" :key="index" :value="s">
                                        {{s}}
                                    </option>
                                </select>
                                <div v-show="errors.has('state')" class="invalid-feedback">
                                    {{ errors.first('state') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" v-model="model.isActive" id="customSwitch1">
                                    <label class="custom-control-label" for="customSwitch1">Ativo</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </form>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import helperService from '../../services/Helper/helperService'
import identityService from '../../services/Identity/identityService'
import editPage from '../../mixins/editPage'
export default {
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            model: {
                givenName: '',
                familyName: '',
                email: '',
                phoneNumber: '',
                password: '',
                userName: '',
                role: this.$auth.userRole,
                claims: [
                    {
                        type: 'parentId',
                        value: this.$auth.userParentId
                    }
                ],
                isActive: false,
                id: '',
                personalInfo: {
                    document: '',
                    regionalDocument: '',
                    gender: 0,
                    birthDate: ''
                },
                address: {
                    street: '',
                    number: '',
                    complement: '',
                    district: '',
                    state: '',
                    city: '',
                    zipCode: ''
                }
            },
            modelValidations: {
                givenName: {
                    required: true,
                    max: 100
                },
                familyName: {
                    required: true,
                    max: 155
                },
                email: {
                    required: true,
                    email: true
                },
                phoneNumber: {
                    required: true,
                },
                document: {
                    required: true,
                },
                regionalDocument: {
                    required: true,
                },
                street: {
                    required: true,
                },
                number: {
                    required: true,
                },
                district: {
                    required: true,
                },
                state: {
                    required: true,
                },
                city: {
                    required: true,
                },
                zipCode: {
                    required: true,
                }
            },
            stateList: [
                'AC',
                'AL',
                'AM',
                'AP',
                'BA',
                'CE',
                'DF',
                'ES',
                'GO',
                'MA',
                'MG',
                'MS',
                'MT',
                'PA',
                'PB',
                'PE',
                'PI',
                'PR',
                'RJ',
                'RN',
                'RO',
                'RR',
                'RS',
                'SC',
                'SE',
                'SP',
                'TO'
            ]
        }
    },
    computed: {
        action() {
            return this.$route.name
        }
    },
    watch: {
        'model.address.zipCode': function(value) {
        if (value && value.length == 8) {
            this.getAddressData(value)
            }
        }
    },
    created(){
        this.fetchUserData()
    },
    methods: {
        fetchUserData() {
            const self = this
            self.showLoading()
            identityService.findUser(this.$auth.externalId).then((response) =>{
                self.model = response.data
                self.model.role = this.$auth.userRole
                self.hideLoading()
            }, () => {
                self.hideLoading()
            })
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    self.model.id = self.$auth.externalId
                    identityService.updateUser(self.model, false).then(() => {
                        self.$store.dispatch('updateUser', {name: self.model.givenName, email: self.model.email})
                        self.hideLoading()
                        self.$router.push({ path:'/dashboard'})
                    })
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        },
        getAddressData(zipCode) {
            const self = this
            self.showLoading()
            helperService.getAddressFromZipCode(zipCode).then(
                response => {
                    if(response && response.erro) {
                        self.hideLoading()
                        return
                    }
                    self.model.address.street = response.logradouro
                    self.model.address.complement = response.complemento
                    self.model.address.district = response.bairro
                    self.model.address.city = response.localidade
                    self.model.address.state = response.uf
                    self.hideLoading()
                },
                () => {
                    self.hideLoading()
                }
            )
        },
        clearZipCodeValue() {
        this.$refs.zipcode.clearValue()
        }
    }
}
</script>
